import type { Translation } from "@/api/orval/model";
import { DEFAULT_LANGUAGE_CODE } from "@/core/i18n";

/* eslint-disable */
export const convertToTranslation = (text: string): Translation => {
  return {
    text,
    languageId: DEFAULT_LANGUAGE_CODE,
    languageShortCode: DEFAULT_LANGUAGE_CODE,
    description: "",
  };
};
